<template>
    <div v-if="showMortgageLoans">
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="banking__1">Mortgage & Loan</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="banking__2">Mortgage & Loan - General Mortgage & Load Details</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Refinance:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
               {{refinance}}
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Jumbo/Non-conforming:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                {{jumbo_non_conforming}}
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                VA:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
               {{va}}
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                FHA:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                {{fha}}
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Conventional:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                {{conventional}}
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                USDA:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            {{usda}}
              
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Correspondent Lending:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            {{correspondent_lending}}
              
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Application Type:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <!-- <v-checkbox v-model="application_type"/> -->
                {{application_type}}
               
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="banking__2">Mortgage & Loan - Regular Pricing Details</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Offered Loan Amount($):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
               {{offered_loan_amount}}
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Maximum Loan Amount($):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                {{maximum_loan_amount}}
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Minimum Loan Amount($):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
               {{minimum_loan_amount}}
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Loan Term (Months):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
              {{loan_term_months}}
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Offered APR (%):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                {{offered_apr}}
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Upper APR (%):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
               {{upper_apr}}
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Lower APR (%):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
               {{lower_apr}}
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Rate Type:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <!-- <v-text-field v-model="rate_type"/> -->
                {{rate_type}}
                
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="banking__2">Mortgage & Loan - Introductory Pricing Details</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Introductory APR (%):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
              {{introductory_apr}}
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Introductory Period (Months):
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
               {{introductory_period_months}}
            </v-col>
        </v-row>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
    name: 'MortgageLoans',
    data: () => ({
        //application_type_options: [{text:'Pre-Approved',value:1},{text:'Pre-Selected',value:2},{text:'Pre-Qualified',value:3},{text:'Guaranteed',value:4},{text:'Invitation to Apply',value:5}],
        //rate_type_options: [{text:'Select One',value:''},{text:'Fixed',value:1},{text:'Variable(Prime)',value:2},{text:'Variable(LIBOR)',value:3}]
    }),
    props : [
        "showMortgageLoans"
    ],
    computed:{
        ...mapGetters({
            sector: 'ProductData/getSector',
            application_types: 'ProductData/getAllApplicationTypes',
            rate_type_options : 'ProductData/getPaymentRateTypes'
        }),
         refinance: {
            get: function() {
                return this.$store.getters['ProductData/getRefinance']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/setRefinance', o)
            }
        },
        jumbo_non_conforming: {
            get: function() {
                return this.$store.getters['ProductData/get_jumbo_non_conforming']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_jumbo_non_conforming', o)
            }
        }, va: {
            get: function() {
                return this.$store.getters['ProductData/get_va']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_va', o)
            }
        }, fha: {
            get: function() {
                return this.$store.getters['ProductData/get_fha']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_fha', o)
            }
        }, conventional: {
            get: function() {
                return this.$store.getters['ProductData/get_conventional']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_conventional', o)
            }
        }, usda: {
            get: function() {
                return this.$store.getters['ProductData/get_usda']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_usda', o)
            }
        }, correspondent_lending: {
            get: function() {
                return this.$store.getters['ProductData/get_correspondent_lending']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_correspondent_lending', o)
            }
        },application_type: {
            get: function() {
                return this.$store.getters['ProductData/get_application_type']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_application_type', o)
            }
        },mortgage_loan_regular_pricing_details: {
            get: function() {
                return this.$store.getters['ProductData/get_mortgage_loan_regular_pricing_details']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_mortgage_loan_regular_pricing_details', o)
            }
        },offered_loan_amount: {
            get: function() {
                return this.$store.getters['ProductData/get_offered_loan_amount']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_offered_loan_amount', o)
            }
        },maximum_loan_amount: {
            get: function() {
                return this.$store.getters['ProductData/get_maximum_loan_amount']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_maximum_loan_amount', o)
            }
        },minimum_loan_amount: {
            get: function() {
                return this.$store.getters['ProductData/get_minimum_loan_amount']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_minimum_loan_amount', o)
            }
        },loan_term_months: {
            get: function() {
                return this.$store.getters['ProductData/get_loan_term_months']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_loan_term_months', o)
            }
        },offered_apr: {
            get: function() {
                return this.$store.getters['ProductData/get_offered_apr']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_offered_apr', o)
            }
        },upper_apr: {
            get: function() {
                return this.$store.getters['ProductData/get_upper_apr']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_upper_apr', o)
            }
        },lower_apr: {
            get: function() {
                return this.$store.getters['ProductData/get_lower_apr']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_lower_apr', o)
            }
        },
        rate_type: {
            get: function() {
                return this.$store.getters['ProductData/get_rate_type']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_rate_type', o)
            }
        },
        mortgage_loan_introductory_pricing_details: {
            get: function() {
                return this.$store.getters['ProductData/get_mortgage_loan_introductory_pricing_details']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_mortgage_loan_introductory_pricing_details', o)
            }
        },
        introductory_apr: {
            get: function() {
                return this.$store.getters['ProductData/get_introductory_apr']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_introductory_apr', o)
            }
        },
        introductory_period_months: {
            get: function() {
                return this.$store.getters['ProductData/get_introductory_period_months']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_introductory_period_months', o)
            }
        },
    }
}
</script>

<style lang="sass" scoped>
@import './../../assets/sass/product/banking'
</style>